var _path, _circle, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 116,
    viewBox: "0 0 71 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 1.5H57.5L41 49L48.5 52L65.5 1.5Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 80,
    r: 35,
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5L22 48.5L29.5 46.5L14 1Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 1.5H40.5L26 45.5L33 47.5L48.5 1.5Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 1H23L32.5 31L38 20.5L31.5 1Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2812 89.8828V96H23.1953C23.4453 93.6875 24.1953 91.5 25.4453 89.4375C26.6953 87.3594 29.1641 84.6094 32.8516 81.1875C35.8203 78.4219 37.6406 76.5469 38.3125 75.5625C39.2188 74.2031 39.6719 72.8594 39.6719 71.5312C39.6719 70.0625 39.2734 68.9375 38.4766 68.1562C37.6953 67.3594 36.6094 66.9609 35.2188 66.9609C33.8438 66.9609 32.75 67.375 31.9375 68.2031C31.125 69.0312 30.6562 70.4062 30.5312 72.3281L23.9688 71.6719C24.3594 68.0469 25.5859 65.4453 27.6484 63.8672C29.7109 62.2891 32.2891 61.5 35.3828 61.5C38.7734 61.5 41.4375 62.4141 43.375 64.2422C45.3125 66.0703 46.2812 68.3438 46.2812 71.0625C46.2812 72.6094 46 74.0859 45.4375 75.4922C44.8906 76.8828 44.0156 78.3438 42.8125 79.875C42.0156 80.8906 40.5781 82.3516 38.5 84.2578C36.4219 86.1641 35.1016 87.4297 34.5391 88.0547C33.9922 88.6797 33.5469 89.2891 33.2031 89.8828H46.2812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver2);
export default __webpack_public_path__ + "static/media/silver_2.126bcf1ac0fa9d75bc5b0bdcd2b11a0e.svg";
export { ForwardRef as ReactComponent };